import { PayoutApiResponse, PayoutTableRow, PayoutWithId } from '../types';

export const createPayoutTableRow = (payout: PayoutWithId): PayoutTableRow => {
    return {
        id: payout._id,
        _id: payout._id,
        transferDate: payout.transferDate,
        amount: payout.amount,
        currency: payout.currency,
        periodStart: payout.period.startDate,
        periodEnd: payout.period.endDate,
        status: payout.status,
        reference: payout.reference,
        publisherId: payout.publisherId,
        period: payout.period
    };
};

export const transformPayoutsToTableData = (payouts: unknown): PayoutWithId[] => {
    if (!Array.isArray(payouts)) return [];

    return payouts.map((payout: PayoutApiResponse) => ({
        _id: payout.id,
        ...payout
    }));
};

